import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useLang } from "../contexts/LanguageContext";

export default function NavMenu({ user }) {
  const { t } = useLang();
  const { pathname } = useLocation();
  const items = [
    { to: "/", label: t("global_feed"), id: "feed" },
    { to: "/c", label: t("hubs"), id: "hubs" },
    { to: "/categories", label: t("genres"), id: "categories" },
  ];
  if (user && !user.is_premium) items.push({ to: "/upgrade", label: t("upgrade"), id: "upgrade" });
  if (!user) items.push({ to: "/login", label: t("sign_in"), id: "login" });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="lg:hidden p-2 text-zinc-400 hover:text-zinc-50 border border-zinc-800 hover:border-zinc-600 transition-colors"
        aria-label="Menu"
        data-testid="nav-menu-trigger"
      >
        <Menu size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[180px] rounded-none border-zinc-800 bg-[#2B333B] text-zinc-200"
        data-testid="nav-menu-content"
      >
        {items.map((it) => (
          <DropdownMenuItem key={it.id} asChild className={`rounded-none font-light focus:bg-zinc-800 focus:text-zinc-50 ${pathname === it.to ? "text-sienna-400" : ""}`}>
            <Link to={it.to} data-testid={`nav-menu-${it.id}-link`}>{it.label}</Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
